// src/contexts/DetailsContext.js
import React, { createContext, useState, useEffect } from 'react';

export const DetailsContext = createContext();
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const DetailsProvider = ({ children }) => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(`${apiBaseUrl}/details`);
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
        setDetails(data);
      } catch (err) {
        setError(err.message || 'Error fetching data');
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, []);

  return (
    <DetailsContext.Provider value={{ details, loading, error }}>
      {children}
    </DetailsContext.Provider>
  );
};
